import {spotheroPost} from 'api';
import dayjs from 'utils/dayjs';
import {camelizeKeys, convertKeysToSnakeCase} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';

import {
    EventAttributionListRequest,
    GetEventAttributionListResponse,
    RawEventAttributionListRequest,
    EventAttributionListItem,
} from './events.types';
import {apiDateFormat} from 'utils/date-time';

/**
 * Formats the events list response.
 */
const formatResponse = (data: GetEventAttributionListResponse) => {
    const formatedData = camelizeKeys(data);

    return formatedData;
};

/**
 * Formats the request to get the events list.
 */
const formatRequest = (
    data: EventAttributionListRequest
): RawEventAttributionListRequest => {
    const updatedData = {
        ...data,
        fromDate: data.fromDate && dayjs(data.fromDate).format(apiDateFormat),
        toDate: data.toDate && dayjs(data.toDate).format(apiDateFormat),
    };

    const formattedData = convertKeysToSnakeCase(updatedData);

    return formattedData;
};

/**
 * Gets a list of events for an array of facilities and date range.
 * @see https://spothero.com/api/v1/docs/endpoints/
 */
const getEventAttributionList = async (
    requestData: EventAttributionListRequest,
    config = {}
) => {
    try {
        const formattedRequest = formatRequest(requestData);

        const response = await spotheroPost<EventAttributionListItem[]>(
            `events/event-attribution-list/`,
            formattedRequest,
            config,
            false
        );
        const formatedResponse = formatResponse(response.data);

        return formatedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventAttributionList;
